<template>
	<div class="bodycont">
		 <div class="cont Pub_width">
			 <div class="nav">
				 当前位置:<span @click="goindex()">首页>&nbsp;</span><span @click="goback()">{{data.sortname}}>&nbsp;</span><span style="color: #005b9f;">{{data.title}}</span>
			 </div>
			 <div class="richtext">
				 <div class="richtitle" v-if="data.title">{{data.title}}</div>
				 <div class="richtime" v-if="data.date">发布时间:{{data.date}}</div>
				 <!-- <div class="richdesc" v-if="data.description">{{data.description}}</div> -->
				 <div class="richtextcont">
					<div class="pub_imgcont" v-html="data.content"></div> 
				 </div>
			 </div>
		 </div>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				data:[]
			}
		},
		methods:{
			loaddetail(){
				let id=this.$route.query.id
				this.$Get("api.php/content/"+id).then(res=>{
					this.data=res.data.data
				})
			},
			goindex(){
				this.$router.push({name:"index_page"})
			},
			goback(){
				this.$router.go(-1)
			}
		},
		created() {
			this.loaddetail()
		}
	})
</script>

<style scoped="scoped">
	.nav{
		background: white;
		margin-top: 20px;
		margin-bottom: 20px;
		border-radius: 5px;
		width: 100%;
		height: 58px;
		background-color: white;
		border-radius: 5px;
		line-height: 58px;
		padding-left: 20px;
		font-size: 14px;
		cursor: default;
	}
	.nav>span:hover{
		    color: #005b9f;
			text-decoration: underline;
	}
	.richtext{
		background: white;
		border-radius: 5px;
	}

	.richtitle{
		font-size: 18px;
		display: inline-block;
		width: 100%;
		text-align: center;
		color: #005b9f;
		padding: 10px 0px;
	}
	.richtime{
		font-size: 14px;
		color: #797979;
		padding-top: 10px;
		text-align: center;
	}
	.richdesc{
		color: rgb(16, 11, 205);
		font-size: 13px;
		text-align: center;
		padding: 10px 0px;
	}
	.richtextcont{
		padding: 15px;
	}
	.richtext img{
		max-width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/view/detail.vue